import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AnthropicIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M10.961 2.998H8.848l3.854 10h2.114zm-6.106 0L1 12.998h2.155l.789-2.1h4.032l.789 2.1h2.155l-3.855-10zM4.64 9.041l1.32-3.515 1.319 3.515z"
		></path>
	</svg>
))
